import type { FC } from 'react';
import React from 'react';
import { Modal } from '../../modal';
import { ModalSize } from '../../modal/components/ModalWrapper';

export const TAX_MODAL_WIDTH = 960;

interface AddInvestmentCommonModalProps {
  onClose: () => void;
  size?: ModalSize | number;
}

export const AddInvestmentCommonModal: FC<React.PropsWithChildren<AddInvestmentCommonModalProps>> = ({
  children,
  onClose,
  size = ModalSize.XLarge,
}) => (
  <Modal size={size} noPadding className="h-[75vh] flex flex-col" onClose={onClose}>
    {children}
  </Modal>
);
